import { Component, OnInit } from '@angular/core';
import { SubmissionsService } from '../../services/submissions.service';
import { UsersService } from '../../services/users.service';
import { GroupsService } from '../../services/groups.service';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'app-queries',
  templateUrl: './queries.component.html',
  styleUrls: ['./queries.component.css']
})
export class QueriesComponent implements OnInit {
  public submissions:Array<any> = [];
  users;
  groups;

  constructor(
    private submissionsService: SubmissionsService,
    private usersService: UsersService,
    private groupsService: GroupsService
  ) { }

  ngOnInit() {
    Observable.forkJoin(
      this.submissionsService.getAll(),
      this.usersService.getAll(),
      this.groupsService.getAll()
    ).subscribe(([submissions, users, groups]) => {
      // Map users and groups to submissions
      submissions.forEach(submission => {
        submission.engine = users.find(user => {
          return user.id === submission.user_id;
        });
        submission.engine = !!submission.engine ? submission.engine.name : '';

        submission.group = groups.find(group => {
          return group.id === submission.group_id;
        });
        submission.group = !!submission.group ? submission.group.name : '';

        submission.element = {
          id: 1,
          fields: []
        }
      });
      this.users = users;
      this.groups = groups;
      this.submissions = submissions;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/queries/queries.component.ts